/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-type[_ngcontent-%COMP%]{font-size:14px}@media screen and (max-width:330px){.btn-type[_ngcontent-%COMP%]{font-size:10px}}@media screen and (max-width:512px) and (min-width:331px){.btn-type[_ngcontent-%COMP%]{font-size:12px}}.btn-danger.active[_ngcontent-%COMP%]{background-color:#000}.btn.btn-danger[_ngcontent-%COMP%]:active, .btn.btn-danger[_ngcontent-%COMP%]:focus, .btn.btn-danger[_ngcontent-%COMP%]:hover{background-color:#000!important}\n/*# sourceMappingURL=course-entrust.component.css.map*/"];
export { styles as styles };
